import { load } from 'worker-timers-broker';
import { createLoadOrReturnBroker } from './factories/load-or-return-broker';
import { worker } from './worker/worker';
var loadOrReturnBroker = createLoadOrReturnBroker(load, worker);
export var clearInterval = function clearInterval(timerId) {
  return loadOrReturnBroker().clearInterval(timerId);
};
export var clearTimeout = function clearTimeout(timerId) {
  return loadOrReturnBroker().clearTimeout(timerId);
};
export var setInterval = function setInterval(func, delay) {
  return loadOrReturnBroker().setInterval(func, delay);
};
export var setTimeout = function setTimeout(func, delay) {
  return loadOrReturnBroker().setTimeout(func, delay);
};